module.exports = __webpack_public_path__ + "static/media/11_potolok_7.34_0.4f41425f.png";